import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { KeyValue } from '../models/common';
import { CityFilterRequest } from '../models/request';
import { Result } from '../models/common/resultResponse';
import { IRateImportStatusApi } from './base';

const baseRoute: string = 'RateImportStatus';

export class RateImportStatusApi extends IRateImportStatusApi {
  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`);
  }
}
